import * as req from 'api/actions';
import * as c from './constant';

export const getRegions = (name, payload = {}, callback) => req.list(
  `${c.GET_REGIONS}/${name}`,
  '/api/v1/administrators/address/regions',
  payload,
  callback,
);

export const getProvinces = (name, regionCode, payload = {}, callback) => req.list(
  `${c.GET_PROVINCES}/${name}`,
  `/api/v1/administrators/address/provinces`,
  {
    ...payload,
    region_code: regionCode
  },
  callback,
);

export const getMunicipalities = (name, regionCode, provinceCode, payload, callback) => req.list(
  `${c.GET_MUNICIPALITIES}/${name}`,
  '/api/v1/administrators/address/municipalities',
  {
    ...payload,
    region_code: regionCode,
    province_code: provinceCode
  },
  callback,
);

export const getBarangays = (name, regionCode, provinceCode, municipalityCode, payload, callback) => req.list(
  `${c.GET_BARANGAYS}/${name}`,
  '/api/v1/administrators/address/barangays',
  {
    ...payload,
    region_code: regionCode,
    province_code: provinceCode,
    municipality_code: municipalityCode
  },
  callback,
);